module.exports = __webpack_public_path__ + "static/corezoid-oslo-open-api-2016-c048a1a7e8f37d9a3e029cf33daa18dd.png";